<div [@slideInOut]="isVisible ? 'visible' : 'hidden'" [style.top]="(2 + position * 10) + 'vh'" class="notification">
    @if(logo){
        <img [src]="logo" alt="Logo" class="logo"/>
    }
    <div class="content">
        <h3>{{ title || 'Notification' }}</h3>
        <p>{{ message || 'This is an animated notification.' }}</p>
    </div>
</div>